import { IStock, StockGroup } from './stock';
import { Notification } from './notification';
import { IUser } from './user';
import { IStrategy } from './strategy';
export enum Country {
  in = 'in',
  us = 'us'
}
export type DataState = {
  stocks: IStock[];
  notifications: Notification[];
  selectedUsers: IUser[];
  stockGroups: StockGroup[];
  strategies: IStrategy[];
  isAdvanced: boolean;
  country: Country;
};
type Payload = {
  stocks?: IStock[];
  notifications?: Notification[];
  selectedUsers?: IUser[];
  stockGroups?: StockGroup[];
  strategies?: IStrategy[];
  advanced?: boolean;
  country?: Country;
};
export interface DataContextActionProps {
  type: string;
  payload?: Payload;
}

export type DataContextType = {
  stocks: IStock[];
  stockGroups: StockGroup[];
  strategies: IStrategy[];
  notifications: Notification[];
  selectedUsers: IUser[];
  setSelectedUsersToStore: (val: IUser[]) => void;
  fetchAllStockGroups: () => Promise<any>;
  fetchAllStocks: () => Promise<any>;
  isStockGroupFetching: boolean;
  isPrivacyProtectionActivated: boolean;
  isAdvanced: boolean;
  setAdvanced: (advanced: boolean) => void;
  country: Country;
  setCountry: (val: Country) => void;
  fetchAllNotifications: () => Promise<any>;
};

export type StatusContextType = {
  kiteStatus: boolean;
  serverStatus: boolean;
  setKiteStatus: (val: boolean) => void;
  liveTickServerStatus: boolean;
  tickKiteStatus: boolean;
};
